export const API_ENDPOINTS = {
  LOGIN_USER: "auth/signin",
  PATIENT_REGISTER: "auth/mobSignup",
  SAVE_PATIENT_DETAIL: "patient/savePatientRecords",

  LOGOUT_USER: "web/logout",

  ADMIN_DASHBOARD: "admin/dashboard",

  GET_ORG: "orgMaster/getAllOrganizations",
  CREATE_ORG: "orgMaster/createOrg",
  UPDATE_ORG: "orgMaster/updateOrganization",

  GET_BRANCH: "branchMaster/getAllBranches",
  CREATE_BRANCH: "branchMaster/createBranch",
  UPDATE_BRANCH: "branchMaster/updateBranch",
  DELETE_BRANCH: "branchMaster/deleteBranch",
  SEARCH_BRANCH: "branchMaster/searchBranches",

  GET_SPECIALITIES: "specialityMaster/getAllSpecialities",
  CREATE_SPECIALITY: "specialityMaster/createSpeciality",
  UPDATE_SPECIALITY: "specialityMaster/updateSpeciality",
  DELETE_SPECIALITY: "specialityMaster/deleteSpeciality",

  CREATE_ROLE: "roleMaster/createRoleUser",
  GET_ROLES: "roleMaster/getAllRoleAccess",
  UPDATE_ROLE: "roleMaster/updateUserPermissions",
  DELETE_ROLE: "roleMaster/deleteRoleUser",
  SEARCH_ROLE: "roleMaster/searchRoleUsers",

  GET_DOCTORS: "master/getAllDoctor",
  CREATE_DOCTOR: "master/createDoctor",
  UPDATE_DOCTOR: "master/updateDoctor",
  DELETE_DOCTOR: "master/deleteDoctorById",
  SCHEDULE_APPOINTMENT: "doctorSchedule/createDoctorAppointmentSchedule",
  GET_SCHEDULE: "doctorSchedule/getScheduleByDoctorId",
  UPDATE_SCHEDULE: "doctorSchedule/updateDoctorAppointmentSchedule",

  GET_MASTER_INVESTIGATION: "investigationMaster/getAllInvestigations",
  CREATE_MASTER_INVESTIGATION: "investigationMaster/createInvestigation",
  UPDATE_MASTER_INVESTIGATION: "investigationMaster/updateInvestigation",
  DELETE_MASTER_INVESTIGATION: "investigationMaster/deleteInvestigation",

  UPLOAD_IMAGE: "master/uploadImage",
  UPLOAD_PATIENT_DOC: "doctor/uploadPatientDocument",
  GET_UPLOAD_PATIENT: "doctor/getDocumentByPatient",
  DELETE_DOCUMENT: "doctor/deletePatientDocument",

  GET_TODAY_PATIENTS: "docDashboard/getTodayPatientsByDoctor",
  STATUS_COUNTS: "docDashboard/statusCount",
  GET_TODAY_APPOINTMENTS: "appointment/getTodayAppointmentsByDoctor",
  UPDATE_APPOINTMENT_STATUS: "doctor/changeConfirmationStatus",
  RESCHEDULE_APPOINTMENT: "doctorappointment/rescheduleAppointment",
  CANCEL_APPOINTMENT: "doctorappointment/cancelAppointment",

  DOCTOR_SLOTS: "doctor/MobAvailableSlots",
  AVAILABLE_DOCTOR_DETAILS: "patient/WebAvailableDoctors",

  PATIENT_DETAILS: "patient/getPatientMedicalRecords",
  BOOK_APPOINTMENT_BY_PATIENT: "doctorappointment/bookAppointBypatient",

  PATIENT_TODAY_APPOINTMENT: "patient/TodayAppointmentByPatients",
  PATIENT_APPOINTMENT_HISTORY: "patient/getAppointsByPatientWithFilters",

  CREATE_MEDICINE: "patient/orderMedicinesByPatientId",
  GET_MEDICINE: "patient/getPrescriptionsByPatientId",

  SAVE_DAIGNOSIS: "doctor/saveDiagnosis",

  // FCM
  REGISTER_FCM: `videoCall/register`,

  // Call Flow
  START_CALL: `videoCall/start`,
  JOIN_CALL: `videoCall/join`,
  END_CALL: `videoCall/end`,

  // Signaling
  SIGNALING: `videoCall/signaling`, // use like SIGNALING/{roomCode}/offer

  // Extra (if needed)
  NOTIFICATION: `videoCall/notification`,
  HISTORY: `videoCall/history`,
  ROOM_DETAILS: `videoCall/roomDetails`, // append /{roomCode}

  CREATE_VITAL: "doctor/createVital",
  RECEPTIONIST_BOOKING: "receptionist/bookAppointment",
  GET_BOOKING: "receptionist/getAllAppointments",
  SEARCH_BOOKING: "receptionist/searchAppointments",

  GET_ALL_LAB: "test/getAllLabDetails",

  RECEP_RESCHEDULE: "receptionist/rescheduleAppointment",
  RECEP_CANCEL: "receptionist/cancelAppointment",

  VERIFY_OTP: "auth/verifyDeviceOtp",
};
